import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'pcs-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardComponent {
  @Input() cardHeader = '';
  @Input() cardFooter = '';
  @Input() bodyHidden = false;
}
